import React from 'react';
import { Box, Divider, List, ListItem, ListItemText, Typography } from '@mui/material';

const ProductGroupQuoteDetailReview = ({ productGroupName, categoryItems }) => {
    return (
        <Box sx={{ width: '100%', maxWidth: 720}}>
            <Typography variant="h5" gutterBottom>{productGroupName} - Review</Typography>
            <Divider sx={{ mb: 2}} />
            <List dense sx={{ py: 0 }}>
            {categoryItems.map((item, itemIndex) => (
                <ListItem key={itemIndex} sx={{ pl: 4 }}>
                    <ListItemText
                        primary={<>
                            {item.quantity} x <strong>{item.productItemName}</strong> <i>{item.categoryName}</i>
                        </>}
                        secondary={item.fields.map((field, fieldIndex) => (
                            <Typography component="span" variant="body2" key={fieldIndex} sx={{ml: 3}}>
                                {`${field.displayName}: ${field.value || '-'} ${field.uom ? `${field.uom}` : ''}`}
                                <br/>
                            </Typography>
                        ))}
                    />
                </ListItem>
                ))}
            </List>
        </Box>
    );
};

export default ProductGroupQuoteDetailReview;